export default "__VITE_ASSET__D3LjWJ_i__"